module.exports = __webpack_public_path__ + "static/media/09.346caf31.svg";